<template>
	<div class="card card-item"  @dblclick="openRundown()">
		<div class="card-body">
			<div class="card-top d-flex justify-content-between">
				<div class="text-lg pointer" :class="{'disabled': isRundownDisabled, 'opacity-04': isRundownDisabled}" @click="openRundown()">
					{{ item && item.name ? item.name : '' }}
				</div>
				<md-menu
					class="h-fc"
					md-size="small"
					md-direction="bottom-end"
					md-align-trigger>
					<md-button
						class="btn-fluid"
						:md-ripple="false"
						md-menu-trigger>
						<i class="material-icons md-18 p-0 h-fc">more_vert</i>
					</md-button>
					<md-menu-content class="minw-200">
						<md-menu-item
							@click="$emit('pinned', item, true)"
							v-if="!item.is_pinned && (user && user.id === item.user_id) && !isRundownDisabled || isSuperAdmin && !isRundownDisabled && !item.is_pinned">
							{{ $t('Pin') }}
						</md-menu-item>
						<md-menu-item
							@click="$emit('unpinned', item, false)"
							v-if="item.is_pinned && (user && user.id === item.user_id) && !isRundownDisabled || item.is_pinned && isSuperAdmin && !isRundownDisabled">
							{{ $t('Unpin') }}
						</md-menu-item>
						<md-menu-item
							v-if="!isRundownDisabled"
							@click="openRundown()">
							{{ $t('Open') }}
						</md-menu-item>
						<md-menu-item v-if="!item.is_pinned && (user && user.id === item.user_id) && !isRundownDisabled || isSuperAdmin && !isRundownDisabled"
							@click="emit('duplicate')">
							{{ $t('Duplicate') }}
						</md-menu-item>
						<md-menu-item
							v-if="!isRundownDisabled"
							@click="emit('export')">
							{{ $t('Export') }}
						</md-menu-item>
						<md-menu-item
							v-if="!isRundownDisabled"
							class="hidden"
							@click="emit('share')">
							{{ $t('Share') }}
						</md-menu-item>
						<md-menu-item
							v-if="user && user.id === item.user_id && !isRundownDisabled || isSuperAdmin && !isRundownDisabled"
							@click="emit('edit')">
							{{ $t('Edit') }}
						</md-menu-item>
						<md-menu-item
							v-if="user && user.id === item.user_id || isSuperAdmin"
							@click="addInvitation">
							{{ $t('Share') }}
						</md-menu-item>
						<md-menu-item
							v-if="user && user.id === item.user_id || isSuperAdmin"
							@click="emit('remove')">
							{{ $t('Delete') }}
						</md-menu-item>
						<md-menu-item
							v-if="user && user.id === item.user_id || isSuperAdmin"
							@click="emit('sharedfolder')">
							{{ $t('Shared Folder') }}
						</md-menu-item>
						<md-menu-item :id="`status${item.id}`" @mouseover="showStatus(true)" @mouseleave="showStatus(false)"
							v-if="user && user.id === item.user_id || isSuperAdmin">
							{{ $t('Status') }}
							<i class="material-icons text-white md-18 ml-auto">keyboard_arrow_right</i>

						</md-menu-item>
					</md-menu-content>
				</md-menu>
				<ul v-show="isShowStatus" @click="showStatus(false)" @mouseover="showStatus(true)" @mouseleave="showStatus(false)" :id="`statuscontext${item.id}`" class="dropdown-context-status-rundown">
					<li @click="$emit('status', item, 'pre_production')" class="text-white-context pl-4 pb-2 pt-2 pointer">
						<div class="flex-center-left"><div class="status-dot-pre_production mr-3"></div>{{ $t('Pre Production') }}</div>
					</li>
					<li @click="$emit('status', item, 'production')" class="text-white-context pl-4 pb-2 pt-2 pointer">
						<div class="flex-center-left"><div class="status-dot-production mr-3"></div>{{ $t('Production') }}</div>
					</li>
					<li @click="$emit('status', item, 'post_production')" class="text-white-context pl-4 pb-2 pt-2 pointer">
						<div class="flex-center-left"><div class="status-dot-post_production mr-3"></div>{{ $t('Post Production') }}</div>
					</li>
					<li @click="$emit('status', item, 'archive')" class="text-white-context pl-4 pb-2 pt-2 pointer">
						<div class="flex-center-left"><div class="status-dot-archive mr-3"></div>{{ $t('Archive') }}</div>
					</li>
				</ul>
			</div>
				<div class="d-flex justify-content-between">
					<!-- if own -->
					<div class="rd-info" v-if="item && item.user_id === user.id && item.collaborators && item.collaborators.length === 0"></div>
					<!-- if shared by -->
					<div class="truncate-rd-info" v-if="item && item.user_id !== user.id">
						<span class="card-info">Shared by {{item && item.user && item.user.name ? item.user.name : ''}}</span>
					</div>
					<!-- if own -->
					<div class="truncate-rd-info mr-a" v-if="(item && item.user_id === user.id) && item.collaborators && item.collaborators.length > 0">
						<span class="card-info">Shared with {{item.collaborators[0].name}}</span>
						<span class="card-info" v-if="item && item.collaborators && item.collaborators.length > 1"> , </span>
						<span class="card-info" v-if="(item && item.user_id === user.id) && item.collaborators && item.collaborators.length > 1">{{item.collaborators[1] && item.collaborators[1].name}}</span>
					</div>
					<!-- total collab -->
					<div v-tooltip.bottom-end="{ content: collaboratorList }" class="d-flex pt-1" v-if="item && item.collaborators && item.collaborators.length > 0">
						<div class="card-info">{{ item.collaborators && item.collaborators.length }}</div>
						<div class="card-info pl-1">Collaborators</div>
					</div>
				</div>
			<div class="card-divider"></div>
			<div class="card-info flex-center">
				<span>
					<span class="mr-2" v-if="itemsCount && itemsCount > 0">{{ itemsCount }} {{ $t('Assets') }}</span>
					<span class="mr-2" v-if="itemsCount && countActiveUsers > 0">|</span>
					<span v-if="countActiveUsers && countActiveUsers > 0">{{ countActiveUsers }} Active Users</span>
				</span>
				<span class="text-white">{{ dateLabel }}</span>
			</div>
			<div :class="`status-bar-${item.status}`">
			</div>
		</div>
		<!-- generate link form -->
		<collaborator-invitation-form
			@close="isFormInvitationVisible = false"
			v-if="isFormInvitationVisible"
			@generated="linkGenerated"
			:rundown="item"
		/>
		<!-- link modal generated -->
		<modal
			size="small"
			@close="isModalLinkInvitationVisible = false"
			v-if="isModalLinkInvitationVisible">
			<template slot="header">
				<h3>{{ $t('Generated Link') }}</h3>
			</template>
			<template slot="body">
				<div>
					This is your generated invitation link:
				</div>
				<div class="text-primary">
					{{linkGeneratedData.url}}
				</div>
			</template>
			<template slot="footer">
				<div class="w-100 flex-center mt-5">
					<button
						class="btn btn-default"
						@click="isModalLinkInvitationVisible = false">
						{{ $t('Close') }}
					</button>
					<button
						class="btn btn-primary"
						@click="copyLinkInvitation()">
						{{ $t('Copy to Clipboard') }}
					</button>
				</div>
			</template>
		</modal>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import CollaboratorInvitationForm from '@/components/CollaboratorInvitationForm.vue';
import Modal from '@/components/Modal.vue';
import rundownsApi from '@/api/rundowns';
import { duplicateVar, elpisisString, copyToClipboard } from '@/lib/helper';
import utc from 'dayjs/plugin/utc'; // import UTC plugin

dayjs.extend(utc);

export default {
	name: 'RundownCard',
	data() {
		return {
			isFormInvitationVisible: false,
			isModalLinkInvitationVisible: false,
			linkGeneratedData: null,
			isShowStatus: false,
		};
	},
	props: {
		item: {
			type: Object,
		},
	},
	components: {
		CollaboratorInvitationForm,
		Modal,
	},
	methods: {
		emit(type) {
			this.$emit(type, this.item);
		},
		showStatus(status) {
			this.isShowStatus = status;
			const elementId = `status${this.item.id}`;
			const elementIdStatus = `statuscontext${this.item.id}`;
			const element = document.getElementById(elementId);
			const elementStatus = document.getElementById(elementIdStatus);
			const rect = element.getBoundingClientRect();
			elementStatus.style.top = `${rect.top}px`;
			elementStatus.style.left = `${rect.left + 126}px`;
		},
		hasProperty(obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		openRundown() {
			const callback = () => {
				this.$router.push(`/rundowns/editor/${btoa(this.item.slug)}`);
			};
			const errorCallback = () => {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown Items',
					text: 'please contact support!',
				});
			};
			let currentActiveUsers = duplicateVar(this.activeUsers);
			const item = {
				id: this.user.id,
				name: this.user.name,
			};
			if (currentActiveUsers && currentActiveUsers.length >= 1) {
				const index = currentActiveUsers.findIndex(({ id }) => id === this.user.id);
				if (index === -1) currentActiveUsers.push(item);
				else this.$set(currentActiveUsers, index, item);
			} else {
				currentActiveUsers = [item];
			}
			const params = {
				active_users: JSON.stringify(currentActiveUsers),
			};
			rundownsApi.update(this.item.id, params, callback, errorCallback);
		},
		showModalName(name) {
			return elpisisString(name);
		},
		addInvitation() {
			this.isFormInvitationVisible = true;
		},
		linkGenerated(item) {
			this.linkGeneratedData = item;
			this.isModalLinkInvitationVisible = true;
		},
		copyLinkInvitation() {
			copyToClipboard(this.linkGeneratedData.url);
			const message = this.$t('Copied to clipboard');
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Invitation Link',
				text: message,
			});
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isSuperAdmin: 'isSuperAdmin',
		}),
		dateLabel() {
			if (this.item.start_time) {
				return dayjs.utc(this.item.start_time).format('DD/MM/YYYY HH:mm');
			}
			return dayjs.utc(this.item.created_at).format('DD/MM/YYYY HH:mm');
		},
		itemsCount() {
			const metaCount = this.item.__meta__
				&& this.item.__meta__.rundownItems_count
				? this.item.__meta__.rundownItems_count : 0;
			return metaCount;
		},
		activeUsers() {
			const parsedActiveUser = this.item
			&& typeof this.item.active_users === 'string'
			&& this.item.active_users !== '' ? this.item.active_users : null;
			return JSON.parse(parsedActiveUser);
		},
		countActiveUsers() {
			const countActiveUsers = this.activeUsers && this.activeUsers.length > 0 ? this.activeUsers.length : 0;
			return countActiveUsers;
		},
		collaboratorList() {
			const collabResult = [];
			const collab = this.item && this.item.collaborators ? this.item.collaborators : '';
			for (let index = 0; index < collab.length; index++) {
				const element = collab[index].name;
				collabResult.push(` ${element}`);
			}
			return collabResult;
		},
		isRundownDisabled() {
			const disabled = this.item && this.item.is_disabled ? this.item.is_disabled : '';
			return disabled;
		},
	},
};
</script>
